export const VpConditionalWrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

export default VpConditionalWrapper;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpConditionalWrapper/VpConditionalWrapper.jsx